import React from 'react';
import {
	Button,
	Link
} from '@material-ui/core';

const ICON_URL = "https://www.google.com/images/icons/product/chrome_web_store-32.png";
const EXTENSION_URL = "https://chrome.google.com/webstore/detail/tabs-collage/oojclknofkaanfacdbdknfogiakgfalg";

export default function DownloadBtn(props) {
	return (
		<div className="download-btn" {...props}>
			<Button component="a" variant="contained" color="primary" href={EXTENSION_URL}>
				<img src={ICON_URL} width={32} style={{paddingRight: '10px'}}/>
				Download from chrome web store
			</Button>
		</div>
	)
}
